export default "<svg class=\"icon <%= cls %>\"><use xlink:href=\"<%= svgSpritePath %>#<%= icon %>\"/></svg>";